import { useSpring, animated } from '@react-spring/web'
import * as React from 'react'

import { config, type IconProps } from '#app/components/icon'

const Compatibility: React.FC<IconProps> = (props) => {
	const { animate = false, className, width, height } = props

	const [style, api] = useSpring(() => ({
		from: {
			y: 0,
			x: 0,
			rotate: 0,
		},
		config: {
			duration: 800,
		},
	}))

	React.useEffect(() => {
		if (animate) {
			Promise.all(
				api.start({
					to: [
						{
							y: 10,
							x: 10,
							rotate: 30,
						},
						{
							y: 20,
							x: 30,
							rotate: 10,
						},
						{
							y: 30,
							x: 10,
							rotate: 20,
						},
						{
							y: 0,
							x: 0,
							rotate: 0,
						},
					],
				}),
			).catch(console.error)
		}
	}, [animate, api])

	return (
		<animated.span style={style}>
			<svg
				id="Ebene_1"
				data-name="Ebene 1"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 425.2 425.2"
				className={className}
				width={width || config.width}
				height={height || config.height}
			>
				<g // hole without dots on left
				>
					<path // hole without dots on left
						d="m388.46,114.35c-2.81-.21-5.59,1.39-7.81,2.93s-4.22,3.23-6.13,5.08c-2.33,2.25-4.38,4.82-6.58,7.2-3.26,3.51-6.59,6.95-10.01,10.32-12.62,12.43-26.31,23.77-40.99,33.68-25.02,16.88-52.7,29.45-81.77,37.5-3.73,1.03-7.48,1.99-11.25,2.88-1.77.42-3.55.82-5.33,1.21-.89.19-2,.26-2.8.73s-1.23,1.36-1.8,2.04c-5.53,6.67-12.84,11.88-20.08,16.52l2.52,4.32c6.27-4.61,10.87-11.26,14.83-17.87,1.2-2-.77-4.05-2.82-3.67-13.9,2.58-27.93,4.27-42.02,5.28-12.56.9-25.11,1.39-37.59,3.19-7.43,1.07-14.95,2.45-22.03,5.01-3.64,1.32-7.31,2.92-10.27,5.48-.37.32-.72.66-1.04,1.02-.25.29-.5.6-.72.9-.04.06-.1.12-.14.19-.65,1.2.58-.39.8-.23-.14-.1-1.27.22-1.41.24-.99.13-2.14.23-3.2.29-2.47.14-5.05.16-7.46-.49-5.89-1.58-11.7-4.08-17.37-6.29s-10.65-4.57-15.88-7.16c-4.35-2.15-9-4.51-13.84-5.32-2.91-.49-6.14-.34-8.31,1.94-3.68,3.86-.16,9.72,3.19,12.4,2.12,1.7,4.63,2.57,7.14,3.51,15.98,5.98,32.21,11.52,48.57,16.36,1.66.49,3.33.97,5.01,1.42,1.57.42,3.16-.78,3.16-2.41v-.25h-5l.03.26,3.76-2.16-.03-.02c-1.65-.83-3.78.17-3.76,2.16.03,4.12,1.7,8.11,3.57,11.71,3.48,6.68,8.25,12.72,13.1,18.45,7.84,9.25,18,15.35,29.54,18.9,20.98,6.46,44.03,5.37,65.46,1.97,4.99-.79,10.01-1.68,14.91-2.96,2.79-.73,2.11-4.8-.66-4.91-17.05-.69-34.02-5.93-49.02-13.97-1.24-.66-2.47-1.34-3.66-2.08l-1.93,4.57c8.47,2.55,17.19,4.42,25.89,5.96,17.21,3.06,34.91,4.76,52.38,3.24,15.18-1.32,29.43-6.12,43.24-12.38,12.9-5.85,25.28-12.83,37.25-20.38,6.46-4.07,12.88-8.28,19.02-12.82,2.14-1.58,1-5.41-1.93-4.57-5.97,1.71-12.89,1.62-19.33,1.85-7.81.28-15.65.36-23.46.14-1.33-.04-2.66-.08-3.99-.16-.42-.03-.85-.05-1.27-.09-.19-.02-.39-.04-.58-.06-.58-.04.32.11.1.02-.26-.11-.74-.33-.97-.38-.98-.2-1.86,2.29-.83,2.51.14.03.31-.03.45-.03.9.02,1.86-.18,2.74-.28,8.57-.98,17.12-2.2,25.65-3.46,5.28-.78,10.55-1.59,15.81-2.45,4.44-.73,9.05-1.25,13.37-2.54,7.72-2.31,14.22-7.4,19.47-13.39,6.82-7.78,12-16.91,16.65-26.11,2.89-5.72,5.56-11.55,8.14-17.42,2.77-6.29,5.3-12.64,6.99-19.31,2.54-10.05,3.47-20.62,1.8-30.89-.56-3.43-1.44-6.79-2.82-9.98-.85-1.98-1.94-4.06-3.58-5.5-.66-.58-1.51-1.17-2.4-1.3-1.35-.19-2.67.33-3.08,1.75-.34,1.17.41,2.89,1.75,3.08.72.1-.33-.18.2.04.46.19.05.02,0-.03.16.15.32.29.47.44.13.14.25.28.37.42-.03-.03-.17-.26.09.13.3.46.6.92.86,1.4,1.37,2.48,2.2,5.3,2.85,8.32,2.06,9.61,1.27,19.81-.97,29.31-3.01,12.83-8.95,25.02-14.85,36.75-4.6,9.13-9.68,18.34-16.56,25.99-5.12,5.69-11.35,10.38-18.94,12.05-9.93,2.19-20.15,3.43-30.21,4.89-7.59,1.1-15.2,2.24-22.84,3-.89.09-1.89.05-2.76.24-2.8.62-3.6,3.67-1.62,5.69s4.41,2.07,6.94,2.2c7.08.38,14.19.3,21.28.16,7.69-.16,15.47-.34,23.08-1.5,1.12-.17,2.24-.37,3.33-.68l-1.93-4.57c-15.68,11.6-32.71,21.82-50.23,30.35-12.82,6.25-26.46,11.83-40.66,13.87-17.32,2.48-35.25,1.16-52.45-1.59-10.29-1.64-20.61-3.76-30.6-6.76-2.76-.83-4.3,3.1-1.93,4.57,3.39,2.11,7.02,3.88,10.65,5.53,8.24,3.76,16.85,6.76,25.7,8.72,6.2,1.37,12.51,2.23,18.86,2.48l-.66-4.91c-12.64,3.29-25.75,4.83-38.77,5.28-21.27.73-46.15-1.79-62.17-17.41-5.76-5.62-10.9-12.42-14.99-19.35-1.3-2.21-2.51-4.48-3.33-6.87-.33-.96-.59-1.93-.81-2.93-.03-.15-.05-.29-.08-.44-.08-.44,0,.33-.05-.38-.03-.38-.05-.76-.06-1.15l-3.76,2.16.03.02c1.49.75,4.02-.12,3.76-2.16l-.03-.26c-.39-3.1-5-3.31-5,0v.25l3.16-2.41c-16.24-4.36-32.19-10.07-48.01-15.74-2.59-.93-5.17-1.86-7.73-2.86-.33-.13-.66-.26-.99-.4-.37-.15.58.29.09.04-.46-.24-.93-.45-1.37-.72-1.57-.97-3.54-2.88-3.73-4.85-.06-.61.03-.72.44-1.15-.33.35-.06.03.17-.07.51-.22-.32.06.37-.15.13-.04.74-.17.48-.13s.44-.03.57-.03c.8,0,1.16.03,1.76.13,4.75.85,9.26,3.2,13.52,5.35,10.42,5.27,21.48,9.67,32.62,13.18,4.43,1.4,9.41,1.05,13.95.39,1.61-.23,2.8-.58,3.57-2.22.28-.59-.43.41-.02.01.15-.15.28-.32.43-.48.34-.36.72-.67,1.09-.99.44-.39-.38.27-.05.03.12-.08.23-.17.35-.26.3-.2.59-.41.9-.6.7-.44,1.43-.85,2.17-1.23.42-.21.84-.42,1.27-.61.63-.29.93-.41,1.13-.5,6.09-2.46,12.58-3.88,19.03-4.99,11.33-1.95,22.79-2.68,34.26-3.34,13.36-.77,26.69-2.09,39.92-4.13,3.48-.54,6.95-1.13,10.41-1.77l-2.82-3.67c-3.48,5.81-7.51,12.01-13.03,16.07-2.53,1.86-.24,6.09,2.52,4.32,6.43-4.12,12.74-8.67,18.15-14.09,1.28-1.28,2.49-2.62,3.61-4.03l.39-.51c.54-.64.4-.56-.42.22.03.05,1.22-.26,1.32-.28.89-.19,1.77-.39,2.65-.59,3.22-.73,6.42-1.5,9.61-2.33,13.81-3.58,27.34-8.15,40.48-13.7,30.16-12.75,57.81-30.85,81.88-53.03,7.82-7.21,15.26-14.83,22.31-22.79,1.44-1.62,3.01-3.09,4.68-4.47,1.95-1.61,4.81-4,7.35-3.81,3.21.24,3.19-4.76,0-5Z"
					/>
					<path // dot on left
						d="m192.23,235.53c-.17.09-.33.19-.5.28l2.52,4.32c.71-.45,1.42-.89,2.13-1.34l-2.52-4.32c-.53.38-1.07.73-1.64,1.06-.29.16-.53.37-.7.64-.22.24-.37.52-.45.85-.1.33-.12.66-.04,1,.02.33.11.64.3.93l.39.51c.31.31.68.52,1.1.64l.66.09c.45,0,.87-.12,1.26-.34.56-.32,1.11-.68,1.64-1.06.29-.16.53-.37.7-.64.22-.24.37-.52.45-.85.1-.33.12-.66.04-1-.02-.33-.11-.64-.3-.93l-.39-.51c-.31-.31-.68-.52-1.1-.64l-.66-.09c-.45,0-.87.12-1.26.34-.71.45-1.42.89-2.13,1.34-.29.16-.53.37-.7.64-.22.24-.37.52-.45.85-.1.33-.12.66-.04,1,.02.33.11.64.3.93l.39.51c.31.31.68.52,1.1.64l.66.09c.45,0,.87-.12,1.26-.34.17-.09.33-.19.5-.28.29-.16.53-.37.7-.64.22-.24.37-.52.45-.85.1-.33.12-.66.04-1-.02-.33-.11-.64-.3-.93l-.39-.51c-.31-.31-.68-.52-1.1-.64l-.66-.09c-.45,0-.87.12-1.26.34Z"
					/>
				</g>
				<path // ???
					d="m129.6,262.75s0,0-.02-.01v-.15c0,.06.01.11.02.16Z"
				/>
				<path // ???
					d="m191.67,253.12c-.33.24-.66.45-.99.64-.11.06-.21.12-.3.17.35-.22.79-.49,1.29-.81Z"
				/>
				<path // ???
					d="m129.6,262.75s0,0-.02-.01v-.15c0,.06.01.11.02.16Z"
				/>
				<path // ???
					d="m191.67,253.12c-.33.24-.66.45-.99.64-.11.06-.21.12-.3.17.35-.22.79-.49,1.29-.81Z"
				/>
			</svg>
		</animated.span>
	)
}

export { Compatibility }
